import React from "react"
import { postExcel } from "@ui-seeker/utils"
import { Skeleton } from "@mui/material"

import { isLoadingCommonFilters } from "@signals"
import { BITable } from "./@components"
import { BIAggregationPrice, BIFilters, BIIs3DTable, BIIsLoadingTable, BISelectedOfficeOptions, BITableData } from './@signals'
import { BACKEND_APIS } from "@constants"


export default function BITableContent() {

	if ((!BITableData.value.rowValues?.length && !BISelectedOfficeOptions.value?.length) || BIIs3DTable.value ) return null
	if (BIIsLoadingTable.value || isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500}/>

	return <BITable
		dataTable={BITableData.value.trows?.[BIAggregationPrice.value] || []}
		columnValues={BITableData.value.columnValues}
		filters={BIFilters.value}
		options={{
			onDownload: () => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, BIFilters.value)
		}}
	/>
}